import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "email",
  "use": "email-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"email\"><path d=\"M510 410c1-3 2-6 2-10V112c0-4-1-7-2-10L343 247zM256 282l44-36 22-18L490 82c-3-1-6-1-9-1H31c-3 0-6 0-9 1l168 146 22 18zm225 149c3 0 6 0 9-1L321 266l-65 54-65-54L22 430c3 1 6 2 9 2h450zM2 102c-1 3-2 6-2 10v288c0 4 1 7 2 10l167-163z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/email.svg
// module id = 191
// module chunks = 0